import { IConfig } from '@cian/config/shared';

import { getOfferChatOnboarding } from './internal/getOfferChatOnboarding';
import { TOfferDataParam } from './types';
import { TChatOnboarding } from 'shared/types/chatOnboarding';

interface IParams {
  config: IConfig;
  data: TOfferDataParam;
}

export function getChatOnboarding({ config, data }: IParams): TChatOnboarding {
  const page = data.jsonQuery?.page?.value;

  if (page && page > 1) {
    return {
      offerChatOnboarding: null,
    };
  }

  return {
    offerChatOnboarding: getOfferChatOnboarding({ config, data }),
  };
}
